<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5 class="mb-0"><i class="fa fa-fw fa-arrow-left mr-2" />Kirim Balik PGI</h5>
            <hr />
            <b-row>
                <b-col md="3">
                    <b-form-group label="Tgl. Pembatalan Dari">
                        <b-form-input type="date" v-model="filter.startDate" @keydown.enter="getItems" />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Tgl. Pembatalan Sampai">
                        <b-form-input type="date" v-model="filter.endDate" @keydown.enter="getItems" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="3">
                    <b-form-group label="No. Faktur">
                        <b-form-input v-model="filter.noFaktur" maxlength="50" @keydown.enter="getItems" />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Office">
                        <b-form-select v-model="filter.office" :options="optFilterOffice" />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Aksi">
                        <b-button variant="primary" @click="getItems()" class="mr-2">
                            <i class="fa fa-search mr-2" />Cari
                        </b-button>
                    </b-form-group>
                </b-col>
                <b-col md="3" class="text-right">
                    <b-form-group label="Tambah">
                        <b-button  variant="danger" @click="showModalSearch">
                            <i class="fa fa-fw fa-times mr-2" />Cancel Kirim Balik
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-table bordered hover show-empty no-local-sorting
                :busy="isBusy"
                :items="items"
                :fields="fields"
                @sort-changed="onSortChanged"
                responsive class="mb-3"
            >
                <template v-slot:empty>
                    Tidak ada data pengembalian barang.
                </template>
                <template v-slot:cell(noFaktur)="row">
                    {{ row.item.inventory.no_faktur_pgi }}
                    <div class="small text-muted">
                        <strong>{{ row.item.inventory.imei_sn }}</strong>
                    </div>
                </template>
                <template v-slot:cell(inventory)="row">
                    {{ row.item.inventory.item_type.name }} <span v-if="row.item.inventory.year != null">({{ row.item.inventory.year }})</span>
                    <div class="small text-muted">
                        {{ row.item.inventory.item_type.brand.kind.name }} - {{ row.item.inventory.item_type.brand.name }}
                    </div>
                </template>
                <template v-slot:cell(returnTo)="row">
                    Ke : {{ row.item.source }}<br />
                    Dari : {{ row.item.office }}
                </template>
                <template v-slot:cell(created)="row">
                    {{ $helper.parseDate(row.item.created_at) }}, {{ $helper.parseHourMinute(row.item.created_at) }}
                    <div class="small text-muted">
                        {{ row.item.request_note }}
                    </div>
                </template>
                <template v-slot:cell(process)="row">
                    <div v-if="row.item.processed_at != null">
                        {{ $helper.parseDate(row.item.processed_at) }}, {{ $helper.parseHourMinute(row.item.processed_at) }}
                    </div>
                    <div v-else>
                        -
                    </div>
                </template>
                <template v-slot:cell(cancel)="row">
                    {{ $helper.parseDate(row.item.cancel_at) }}, {{ $helper.parseHourMinute(row.item.cancel_at) }}
                    <div class="small text-muted">
                        {{ row.item.cancel_note }}
                    </div>
                </template>
                <template v-slot:cell(action)="row">
                    <div v-if="row.item.status == 0">
                        <b-button size="sm" variant="success" v-b-tooltip.hover.top title="Kirim Balik" @click="acceptRequest(row.item)">
                            <i class="fa fa-fw fa-check" />
                        </b-button>
                        <b-button size="sm" class="ml-2" variant="danger" v-b-tooltip.hover.top title="Tolak" @click="rejectRequest(row.item)">
                            <i class="fa fa-fw fa-times" />
                        </b-button>
                    </div>
                    <b-button v-else size="sm" variant="primary" v-b-tooltip.hover.top title="Info" @click="openInfo(row.item)">
                        <i class="fa fa-fw fa-info" />
                    </b-button>
                </template>
            </b-table>
            <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange" @page-change="onPageChange" />
        </b-card>
        <b-modal id="m-info" title="Informasi Kirim Balik" centered no-close-on-backdrop hide-footer>
            Informasi untuk NF <strong>{{ info.noFaktur }}</strong>
            <div class="mt-4">
                <div>
                    <strong>Request kirim balik pada</strong><br />
                    {{ $helper.parseDate(info.requestedAt) }}, {{ $helper.parseHourMinute(info.requestedAt) }}<br />
                    Catatan: {{ info.requestNote }}
                </div>
                <div class="mt-4">
                    <strong>Diproses oleh / pada</strong>
                    <div>
                        {{ $helper.parseDate(info.processedAt) }}, {{ $helper.parseHourMinute(info.processedAt) }}<br />
                        oleh 
                        <strong v-if="info.processedBy != null">{{ info.processedBy.fullname }}</strong>
                        <strong v-else> - </strong>
                    </div>
                </div>
                <div class="mt-4">
                    <strong>Dibatalkan oleh / pada</strong>
                    <div>
                        {{ $helper.parseDate(info.cancelAt) }}, {{ $helper.parseHourMinute(info.cancelAt) }}<br />
                        oleh 
                        <strong v-if="info.cancelBy != null">{{ info.cancelBy.fullname }}</strong>
                        <strong v-else> - </strong>
                    </div>
                </div>
            </div>
        </b-modal>
        <b-modal id="m-cancel-search" title="Cancel Kirim Balik" no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="No. Faktur">
                <b-input v-model="inputSearch.noFaktur" maxlength="100" />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="searchReturnData">
                    {{ isSubmitting ? "Mencari..." : "Check" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-cancel-item" title="Informasi Kirim Balik" no-close-on-backdrop hide-footer>
            Informasi untuk NF <strong>{{ infoSearch.noFaktur }}</strong>
            <div class="mt-4">
                <div>
                    Jenis Barang: <strong>{{ infoSearch.kind }}</strong> 
                </div>
                <div>
                    Merk Barang: <strong>{{ infoSearch.brand }}</strong>
                </div>
                <div>
                    Tipe Barang: <strong>{{ infoSearch.type }}</strong>
                </div>
                <div>
                    Imei Barang: <strong>{{ infoSearch.imei }}</strong>
                </div>
            </div>

            <div class="mt-4">
                <div>
                    Tanggal Request: <strong>{{ $helper.parseDate(infoSearch.requestedAt) }}, {{ $helper.parseHourMinute(infoSearch.requestedAt) }}</strong>
                </div>
                <div>
                    Tanggal Proses: 
                    <strong v-if="infoSearch.processedAt != null">{{ $helper.parseDate(infoSearch.processedAt) }}, {{ $helper.parseHourMinute(infoSearch.processedAt) }}</strong>
                    <strong v-else> - </strong>
                </div>
            </div>
            <hr />
            <b-form-group label="Alasan">
                <b-input v-model="input.notes" maxlength="100" />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="confirmCancellation">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    data() {
        return {

            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            show: 10,

            filter: {
                noFaktur: "",
                status: -1,
                startDate: "",
                endDate: ""
            },

            inputSearch: {
                noFaktur: ""
            },

            input: {
                noFaktur: "",
                notes: ""
            },

            info: {
                noFaktur: "",
                requestedAt: null,
                requestNote: null,
                processedBy: null,
                processedAt: null,
                cancelBy: null,
                cancelAt: null,
                cancelNote: null
            },

            infoSearch: {
                noFaktur: "",
                imei: "",
                brand: "",
                kind: "",
                type: "",
                processedAt: null,
                requestedAt: null
            },

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            fields: [
                { key: "noFaktur", label: "No. Faktur / IMEI", sortable: true },
                { key: "inventory", label: "Barang", sortable: true },
                { key: "returnTo", label: "Pengembalian", sortable: true },
                { key: "created", label: "Tgl. Request", sortable: true },
                { key: "process", label: "Tgl. Proses", sortable: true },
                { key: "cancel", label: "Tgl. Batal", sortable: true },
                { key: "action", label: "Aksi" },
            ],

            items: [],
            activeItem: {
                id: null,
                inventory: {}
            },
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,

            optFilterOffice: [
                { value: -1, text: "Semua" }
            ],

        }
    },

    methods: {

        init() {

            this.initStatus = 0
            let getItems = this.getItems()
            let getOffices = this.$axios.get("master/offices").then(res => {
                for(let i = 0; i < res.data.data.length; i++){
                    this.optFilterOffice.push({value: res.data.data[i].id, text: res.data.data[i].name})
                }
            })

            Promise.all([getItems, getOffices]).then(() => {
                this.initStatus = 1
            })
            .catch(_ => {
                this.initStatus = -1
            })

        },

        getItems(page = 1) {

            this.isBusy = true
            this.items = []

            if(isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage, this.perPage)

            if(!this.$helper.isBlank(this.filter.noFaktur)) {
                param += "&filterNoFaktur=" + this.filter.noFaktur
            }

            if(this.filter.status != -1) {
                param += "&filterStatus=" + this.filter.status
            }

            if(!this.$helper.isBlank(this.filter.startDate)) {
                param += "&filterStartDate=" + this.filter.startDate
            }

            if(!this.$helper.isBlank(this.filter.endDate)) {
                param += "&filterEndDate=" + this.filter.endDate
            }

            if(this.filter.office != -1) {
                param += "&filterOffice=" + this.filter.office
            }

            if(this.sortBy != null) {
                param += "&sortBy=" + this.sortBy + "&sortDesc=" + this.sortDesc
            }

            return this.$axios.get("inventory-return-cancel-pgi" + param).then(res => {
                this.items = res.data.data.items
                this.totalRows = res.data.data.total
                sessionStorage.setItem("listKirimBalikFilter", JSON.stringify(this.filter))
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        openInfo(item) {

            this.info.noFaktur = item.inventory.no_faktur_pgi
            this.info.processedBy = item.processed_by
            this.info.processedAt = item.processed_at
            this.info.requestedAt = item.created_at
            this.info.requestNote = item.request_note
            this.info.cancelBy = item.cancelled_by
            this.info.cancelAt = item.cancel_at
            this.info.cancelNote = item.cancel_note

            this.$bvModal.show("m-info")

        },

        showModalSearch() {
            this.inputSearch.noFaktur = ""
            this.input.noFaktur = ""
            this.input.notes = ""

            this.$bvModal.show('m-cancel-search')            
        },

        searchReturnData() {
            if(this.$helper.isBlank(this.inputSearch.noFaktur)) {
                return this.$helper.toastError(this, "Mohon mengisi nomor faktur!")
            }

            this.isSubmitting = true

            let payload = {
                noFaktur: this.inputSearch.noFaktur
            }

            this.$axios.post("inventory-return-cancel-pgi/get-return-item-for-cancellation", payload).then(res => {

                let data = res.data.data

                this.infoSearch.noFaktur = data.no_faktur_pgi
                this.infoSearch.brand = data.brand
                this.infoSearch.kind = data.kind
                this.infoSearch.imei = data.imei_sn
                this.infoSearch.type = data.type
                this.infoSearch.requestedAt = data.created_at
                this.infoSearch.processedAt = data.processed_at

                this.input.noFaktur = data.no_faktur_pgi

                this.$bvModal.show("m-cancel-item")
                this.$bvModal.hide("m-cancel-search")

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)
        },

        confirmCancellation() {
            if(this.$helper.isBlank(this.input.notes)) {
                return this.$helper.toastError(this, "Mohon mengisi alasan pembatalan!")
            }

            let isConfirmed = confirm("Batalkan request kirim balik ini?")
            if(!isConfirmed) return

            this.isSubmitting = true

            let payload = {
                noFaktur: this.input.noFaktur,
                note: this.input.notes
            }

            this.$axios.post("inventory-return-cancel-pgi/process", payload).then(_ => {

                this.$helper.toastSuccess(this, "Request berhasil dibatalkan!")
                this.$bvModal.hide("m-cancel-item")
                this.input.notes = ""
                this.getItems(this.currentPage)

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)
        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems(this.currentPage)
        },

        onPageChange(newPage) {
            this.currentPage = newPage
            this.getItems(this.currentPage)
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        }

    },

    created() {
        if(!this.$helper.isBlank(sessionStorage.getItem("listKirimBalikFilter"))){
            this.filter = JSON.parse(sessionStorage.getItem("listKirimBalikFilter"))
        }
        this.init()
    }
}
</script>
